<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="分发设置" name="distribute">
        <el-row>
          <el-input v-model="distributeKeywords" placeholder="输入关键字" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryDistribute()"></el-input>
          <el-button @click="queryDistribute()" icon="el-icon-search" circle title="查询"></el-button>
          <el-button @click="editDistribute()" icon="el-icon-plus" circle title="新建"></el-button>
        </el-row>
        <br>
        <el-table :data="distributeList" border style="width: 100%" height="650" v-loading="distributeLoading">
          <el-table-column prop="title" label="分发命名"></el-table-column>
          <el-table-column prop="platform_email" label="平台邮箱"></el-table-column>
          <el-table-column prop="worktime" label="运行时段"></el-table-column>
          <el-table-column prop="status" label="状态" width="70">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="toggleDistributeStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="220"></el-table-column>
          <el-table-column prop="creator" label="创建人" width="120"></el-table-column>
          <el-table-column label="操作" width="160">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="editDistribute(scope.row)">编辑</el-link>
              <el-link type="danger" :underline="false" @click="deleteDistribute(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="平台邮箱登录" name="platform_emails">
        <el-row>
          <el-input v-model="platformEmailsKeywords" placeholder="输入关键字" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryPlatformEmails()"></el-input>
          <el-button @click="queryPlatformEmails()" icon="el-icon-search" circle title="查询"></el-button>
          <el-button @click="editPlatformEmails()" icon="el-icon-plus" circle title="新增"></el-button>
        </el-row>
        <br>
        <el-table :data="platformEmailsTableList" border style="width: 100%" height="650"
          v-loading="platformEmailsLoading">
          <el-table-column prop="username" label="平台邮箱"></el-table-column>
          <el-table-column prop="status" label="状态" width="70">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
                @change="togglePlatformEmailStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>+
          <el-table-column prop="created_at" label="创建时间" width="220"></el-table-column>
          <el-table-column prop="creator" label="创建人" width="120"></el-table-column>
          <el-table-column label="操作" width="160">
            <template v-slot="scope">
              <el-link type="primary" :underline="false" @click="editPlatformEmails(scope.row)">编辑</el-link>
              <el-link type="danger" :underline="false" @click="deletePlatformEmails(scope.row)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="分发数据统计" name="distribute_statistics">
        暂缓2周开放
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="设置" :visible.sync="distributeVisible" :close-on-click-modal="false" width="1000px">
      <el-form :model="distributeForm" label-width="80px" :rules="distributeFormRules" ref="distributeForm"
        v-loading="distributeFormLoading">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分发命名">
              <el-input v-model="distributeForm.title" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="平台邮箱" prop="platform_email">
              <el-select v-model="distributeForm.platform_email" filterable placeholder="请选择">
                <el-option v-for="item in platformEmailsList" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <el-link :underline="false" type="primary" @click="editPlatformEmails()">新增</el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="生效时间" class="blue">
              {{ distributeForm.worktimes[0] }} 点 - {{ distributeForm.worktimes[1] }} 点
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <el-slider v-model="distributeForm.worktimes" range show-stops :min="0" :max="24" :marks="worktimeMarks"
                style="margin-left: -70px;">
              </el-slider>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item label="分发目标">
              <el-transfer filterable :filter-method="filterSalers" filter-placeholder="搜索"
                v-model="distributeForm.chosenSalers" :data="salersList" :titles="['可选邮箱', '分发目标邮箱']">
              </el-transfer>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="distributeVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDistribute()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="平台邮箱" :visible.sync="platformEmailsVisible" :close-on-click-modal="false" width="600px">
      <el-form :model="platformEmailsForm" label-width="80px" :rules="platformEmailsFormRules" ref="platformEmailsForm"
        v-loading="platformEmailsFormLoading">
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="platformEmailsForm.username" autocomplete="new-password"
                :disabled="platformEmailsFormUsernameDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="platformEmailsForm.password" autocomplete="new-password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="platformEmailsVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPlatformEmails()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'

export default {
  name: 'Customers',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'distribute',
      distributeKeywords: '',
      distributeLoading: false,
      distributeList: [],
      distributeVisible: false,
      distributeFormLoading: false,
      distributeForm: {
        id: '',
        title: '',
        platform_email: '',
        worktimes: [0, 24],
        chosenSalers: []
      },
      distributeFormRules: {
        platform_email: [
          { required: true, message: '平台邮箱不能为空' }
        ]
      },
      platformEmailsList: [],
      salersList: [],
      worktimeMarks: {
        0: "-",
        6: "6点",
        12: "12点",
        18: "18点",
        24: "+"
      },

      platformEmailsKeywords: '',
      platformEmailsLoading: false,
      platformEmailsTableList: [],
      platformEmailsVisible: false,
      platformEmailsFormLoading: false,
      platformEmailsFormUsernameDisabled: false,
      platformEmailsForm: {
        id: '',
        username: '',
        password: ''
      },
      platformEmailsFormRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' }
        ]
      }
    }
  },
  mounted() {
    this.queryDistribute();
    setTimeout(() => {
      this.current_page = 1;
      this.queryDistribute();
    }, 0)
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'distribute':
          this.queryDistribute();
          break;
        case 'platform_emails':
          this.queryPlatformEmails();
          break;
      }
    },
    queryDistribute() {
      this.distributeLoading = true;
      let keywords = this.distributeKeywords;
      this.$axios.get('/mailer/distribute/list', {
        params: {
          keywords: keywords
        }
      }).then((response) => {
        this.distributeLoading = false
        if (response.data.code === 200) {
          this.distributeList = response.data.data;
        }
      })
    },
    filterSalers(query, item) {
      return item.label.indexOf(query) > -1;
    },
    async editDistribute(object = null) {
      if (object !== null) {
        this.distributeForm = {
          id: object.id,
          title: object.title,
          platform_email: object.platform_email_id,
          worktimes: object.worktimes,
          chosenSalers: object.chosenSalers
        }
      } else {
        this.distributeForm = {
          id: '',
          title: '',
          platform_email: '',
          worktimes: [0, 24],
          chosenSalers: []
        }
      }
      this.distributeVisible = true;
      this.distributeFormLoading = true;
      await this.$axios.get(`/mailer/distribute/platform_emails`).then((response) => {
        this.platformEmailsList = response.data.data;
      })
      await this.$axios.get(`/mailer/distribute/salers_list`).then((response) => {
        this.salersList = response.data.data.map(v => ({
          key: v,
          label: v
        }))
      })
      this.distributeFormLoading = false;
    },
    submitDistribute() {
      this.$refs.distributeForm.validate(valid => {
        if (valid) {
          this.$confirm('保存后将立即生效, 确定吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.distributeFormLoading = true;
            this.$axios.post(`/mailer/distribute/save`, this.distributeForm).then((response) => {
              this.distributeFormLoading = false;
              if (response.data.code === 200) {
                this.$notify({
                  type: 'success',
                  title: '保存成功'
                })
                this.distributeVisible = false;
                this.queryDistribute();
              }
            })
          })
        }
      })
    },
    toggleDistributeStatus(row, index) {
      let notice = row.status ? '确定开启吗?' : '关闭后本平台的邮件将停止分发, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response === undefined) {
            this.distributeList[index].status = !row.status;
          }
          if (response.data.code === 200) {
            this.$notify({
              title: message + '成功',
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.distributeList[index].status = !row.status;
      });
    },
    deleteDistribute(row) {
      this.$confirm('此操作不可恢复, 确定删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              type: 'success',
              title: '删除成功'
            })
            this.queryDistribute();
          }
        })
      })
    },


    queryPlatformEmails() {
      this.platformEmailsLoading = true;
      let keywords = this.platformEmailsKeywords;
      this.$axios.get('/mailer/distribute/platform_emails_list', {
        params: {
          keywords: keywords
        }
      }).then((response) => {
        this.platformEmailsLoading = false;
        if (response.data.code === 200) {
          this.platformEmailsTableList = response.data.data;
        }
      })
    },
    async editPlatformEmails(object = null) {
      this.platformEmailsFormUsernameDisabled = object !== null;
      if (object !== null) {
        this.platformEmailsForm = {
          id: object.id,
          username: object.username,
          password: object.password
        }
      } else {
        this.platformEmailsForm = {
          id: '',
          username: '',
          password: ''
        }
      }
      this.platformEmailsVisible = true;
    },
    async submitPlatformEmails() {
      await this.$refs.platformEmailsForm.validate(valid => {
        if (valid) {
          this.platformEmailsFormLoading = true;
          this.$axios.post(`/mailer/distribute/platform_emails_save`, this.platformEmailsForm).then((response) => {
            this.platformEmailsFormLoading = false;
            if (response.data.code === 200) {
              this.$notify({
                type: 'success',
                title: '保存成功'
              })
              this.$axios.get(`/mailer/distribute/platform_emails`).then((response) => {
                this.platformEmailsList = response.data.data;
              })
              this.platformEmailsVisible = false;
              this.queryPlatformEmails();
            }
          })
        }
      })
    },
    togglePlatformEmailStatus(row, index) {
      let message = row.status ? '开启' : '关闭';
      let notice = '确定' + message + '吗?';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/platform_emails_toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response === undefined) {
            this.platformEmailsTableList[index].status = !row.status;
          }
          if (response.data.code === 200) {
            this.$notify({
              title: message + '成功',
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.platformEmailsTableList[index].status = !row.status;
      });
    },
    deletePlatformEmails(row) {
      this.$confirm('此操作不可恢复, 确定删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/mailer/distribute/platform_emails_delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              type: 'success',
              title: '删除成功'
            })
            this.queryPlatformEmails();
          }
        })
      })
    }
  },
  beforeDestroy() {
  }
}
</script>

<style scoped>
.el-transfer {
  width: 830px !important;
}

.el-transfer /deep/ .el-transfer__buttons {
  padding: 0 20px !important;
}

.el-transfer /deep/ .el-button {
  padding: 12px !important;
}

.el-transfer /deep/ .el-transfer-panel {
  width: 350px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/Distribute.vue